import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  viewBox: "0 0 33 32"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22.176 3.842a3.315 3.315 0 0 0-4.346.006c-1.2 1.048-1.118 2.965.025 4.196 1.08 1.164 3.057 1.084 4.327-.025 1.214-1.059 1.235-2.966-.006-4.177m-4.806-.49a4.02 4.02 0 0 1 5.272 0l.014.012c1.501 1.457 1.52 3.812-.014 5.151-1.48 1.292-3.903 1.478-5.298-.025-1.332-1.435-1.524-3.785.026-5.137M11.598 10.056c-1.782-1.844-4.91-1.866-6.85.015-1.931 1.873-1.931 4.785 0 6.658a4.896 4.896 0 0 0 6.866 0c1.931-1.873 1.931-4.785 0-6.658zm.996-.92c-2.344-2.415-6.361-2.39-8.818-.007-2.468 2.393-2.468 6.149 0 8.542a6.3 6.3 0 0 0 8.81 0c2.466-2.39 2.468-6.14.008-8.535",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M2.063 13.333c0-.368.307-.666.687-.666h11c.38 0 .688.298.688.666a.677.677 0 0 1-.688.667h-11a.677.677 0 0 1-.687-.667M28.283 15.24a3.187 3.187 0 0 0-4.454 0l-6.875 6.667c-1.247 1.21-1.247 3.11 0 4.32a3.19 3.19 0 0 0 4.454 0l6.875-6.667c1.247-1.21 1.247-3.11 0-4.32m-5.912-1.414a5.295 5.295 0 0 1 7.37 0c2.053 1.99 2.053 5.157 0 7.148l-6.875 6.666a5.296 5.296 0 0 1-7.37 0c-2.053-1.99-2.053-5.157 0-7.147z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M19.314 17.396a.703.703 0 0 1 .972 0l5.775 5.6a.65.65 0 0 1 0 .943.703.703 0 0 1-.972 0l-5.775-5.6a.65.65 0 0 1 0-.943",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }